import React, { useContext } from 'react';
import c from './custom-theme.module.scss';
import { ThemeContext } from '@/components/providers/theme-provider/ThemeProvider';

const WallpaperButtonUpload = ({ url, number, isNullSelect, image }) => {
  const { updateCustomTheme, customThemeVariables } = useContext(ThemeContext);

  const isSelected = isNullSelect
    ? customThemeVariables.wallpaper === null
    : customThemeVariables.wallpaper === `url('${url}')`;
  return (
    <div className={c.imageFit}>
      <button
        type="button"
        aria-label={url ? `Wallpaper: ${number + 1}` : 'No image'}
        aria-current={isSelected ? 'true' : null}
        className={[
          c.wallpaperButtonUpload,
          isSelected ? c.selected : null,
        ].join(' ')}
        onClick={() => {
          const updates = [
            { attribute: 'wallpaper', value: url ? `url('${url}')` : null },
          ];
          if (customThemeVariables.imageFileName !== undefined) {
            updates.push({
              attribute: 'imageFileName',
              value: customThemeVariables.imageFileName,
            });
          }
          updateCustomTheme(updates);
        }}
      >
        {url ? (
          <img
            className={`custom-theme ${c.wallpaperImage}`}
            src={image?.src}
            alt={`Wallpaper: ${number + 1}`}
            data-tracking-event={'themer-wallpaper-' + (number + 1)}
          />
        ) : isNullSelect ? (
          <span className={`custom-theme ${c.nullFit}`}>No image</span>
        ) : null}
      </button>
    </div>
  );
};

export default WallpaperButtonUpload;
